import type { JSX } from 'react';

import { Button } from '@change/ds-core-ui/Button';
import { Text } from '@change/ds-core-ui/Text';

import { useMidPageCta } from './hooks/useMidPageCta';

export function MidPageCta(): JSX.Element {
	const { actions, data } = useMidPageCta();

	return (
		<div className="bg-background-raised relative z-0 py-14 md:mt-4">
			<div className="container">
				<div className="flex flex-col items-center justify-center gap-6 text-center">
					<Text as="h2" variant="heading" size="small" className="md:text-size-heading">
						Join the most effective petition platform
					</Text>
					<Button
						as="a"
						href={data.ctaUrl}
						variant="primary-strong"
						data-qa="nonprofit-mid-page-get-started-cta"
						onClick={actions.onCtaClick}
					>
						Get started
					</Button>
				</div>
			</div>
		</div>
	);
}
